import { FC } from 'react';
import { useUserDescription, useUserLinkPreviewTitle } from '@user/shared/use-tdk';
import { DynamicHead } from '@lemon8/web-app-shared/ssr';

export const UserTDK: FC = () => {
  const title = useUserLinkPreviewTitle();
  const description = useUserDescription();

  return (
    <DynamicHead>
      <title>{title}</title>
      <meta name="description" content={description} />
    </DynamicHead>
  );
};
